export const propMisc = {
  // valoracionHuespedes.vue
  reviews: {
    title: "Avis des clients",
    subtitle: "Demandez un avis sur WhatsApp le jour du départ. Définissez le lien où vous souhaitez que les clients laissent leur avis.",
    bulkNotice: "Cette modification s'appliquera à tous les {count} hébergements liés à cette annonce.",
    enableTitle: "Activer les avis des clients",
    enableSub: "Un message WhatsApp est envoyé automatiquement le jour du départ pour demander un avis.",
    modeSingleTitle: "Un seul lien",
    modeSingleSub: "Le même pour chaque réservation",
    modePerOtaTitle: "Un lien par OTA",
    modePerOtaSub: "Selon le canal de réservation",
    linkLabel: "Lien de l'avis",
    singleUrlPlaceholder: "https://g.page/r/… ou le lien vers votre page d'avis",
    otaNamePlaceholder: "Nom du site",
    otaUrlPlaceholder: "https://… lien de l'avis",
    removeTitle: "Supprimer",
    addOta: "Ajouter un autre site",
    saving: "Enregistrement…",
    saveConfig: "Enregistrer les paramètres",
    note: "Les clients recevront le lien correspondant selon la manière dont ils ont réservé.",
    toastLoadError: "Impossible de charger les données de l'annonce.",
    urlErrorProtocol: "L'URL doit commencer par http:// ou https://",
    urlErrorInvalid: "Saisissez une URL valide (par ex. https://g.page/...)",
    toastStateUpdated: "Statut mis à jour avec succès",
    toastStateError: "Une erreur s'est produite lors de la mise à jour du statut",
    toastUrlRequired: "Saisissez une URL avant d'enregistrer",
    toastSaved: "Paramètres enregistrés avec succès",
    toastSaveError: "Une erreur s'est produite lors de l'enregistrement",
  },

  // AccessSummary.vue
  access: {
    tag: "Serrures et accès",
    dynamicTitle: "Serrure connectée",
    dynamicDetail: "Chaque réservation génère automatiquement un nouveau code et l'envoie au client.",
    chipCheckin: "Envoyé une fois le check-in effectué",
    chipTime: "Envoyé à {time} le jour de l'arrivée",
    chipManual: "Vous l'envoyez manuellement",
    staticTitle: "Serrure avec code fixe",
    staticDetail: "Le client reçoit le code de la boîte à clés ou de la serrure pour entrer.",
    noneTitle: "Je remets les clés en main propre",
    noneDetail: "Vous organisez la remise des clés avec le client à l'arrivée.",
  },

  // ButtonUpdatePropertyPrice.vue
  updatePrice: {
    update: "Mettre à jour le prix",
    saving: "Enregistrement…",
  },

  // MossosConnections.vue
  mossos: {
    intro: "Liez chaque logement de cette annonce à son établissement Mossos (chaque logement peut avoir son propre identifiant de police). Les check-ins sont envoyés automatiquement au bon établissement selon le logement de la réservation.",
    wholeListing: "Annonce entière",
    wholeListingDefault: "Annonce entière (par défaut)",
    unitNumber: "Logement n°{id}",
    badgeSendError: "Erreur d'envoi",
    badgeConnected: "Connecté",
    badgeNoCredentials: "Aucun identifiant",
    emptyList: "Aucune connexion pour le moment. Ajoutez-en une pour chaque logement de l'annonce.",
    addConnection: "Ajouter une connexion",
    editConnection: "Modifier la connexion",
    newConnection: "Nouvelle connexion",
    unit: "Logement",
    unitPlaceholder: "Choisissez le logement",
    unitHint: "À quel logement de l'annonce appartient cet établissement.",
    step1Title: "Accès au site web des Mossos",
    usuariLabel: "Usuari (site web des Mossos)",
    savedHint: "enregistré",
    usuariPlaceholderKeep: "Laissez vide pour ne pas modifier",
    usuariPlaceholderNew: "Nom d'utilisateur de connexion au site web",
    passLabel: "Paraula de pas",
    passBlankHint: "vide pour ne pas modifier",
    passPlaceholder: "Mot de passe du site web des Mossos",
    validateHint: "Validez pour récupérer les établissements de votre compte.",
    searching: "Recherche…",
    validateSearch: "Valider et rechercher les établissements",
    step2Title: "Établissement pour ce logement",
    establishmentPlaceholder: "Sélectionnez l'établissement",
    revalidateHint: "Validez à nouveau pour le modifier.",
    validateAbove: "Validez ci-dessus pour choisir l'établissement de ce logement.",
    checkinTime: "Heure de facturation (arrivée)",
    checkoutTime: "Heure de départ",
    cancel: "Annuler",
    savingBtn: "Enregistrement...",
    updateConnection: "Mettre à jour la connexion",
    saveConnection: "Enregistrer la connexion",
    warnCredentials: "Saisissez l'usuari et la paraula de pas pour le site web des Mossos.",
    foundEstablishments: "{count} établissement(s) trouvé(s). Choisissez celui de ce logement.",
    noEstablishments: "Aucun établissement trouvé dans ce compte.",
    connectError: "Impossible de se connecter aux Mossos. Vérifiez votre usuari et votre mot de passe.",
    validateFirst: "Validez et choisissez l'établissement pour cette connexion.",
    savedOk: "Connexion Mossos enregistrée.",
    saveError: "Impossible d'enregistrer la connexion.",
    saveErrorGeneric: "Erreur lors de l'enregistrement de la connexion Mossos.",
    confirmDelete: `Supprimer la connexion pour "{unit}" ({id}) ?`,
    deletedOk: "Connexion supprimée.",
    deleteError: "Impossible de supprimer la connexion.",
  },

  // SesAccounts.vue + modalPoliceData.vue — varias cuentas de SES por anuncio
  ses: {
    intro: "Chaque logement déclare ses voyageurs avec un compte SES Hospedajes. Vous pouvez utiliser un seul compte pour toute l'annonce ou en attribuer un autre à certains logements, par exemple si chaque appartement a son propre code d'établissement.",
    defaultName: "Établissement {code}",
    badgeConnected: "Connecté",
    badgeError: "Erreur de validation",
    badgePending: "Non validé",
    user: "Utilisateur",
    lessor: "Propriétaire",
    establishment: "Établissement",
    appliesWhole: "Annonce entière :",
    appliesUnits: "Logements :",
    noUnits: "Aucun logement ne l'utilise",
    allUnits: "Tous les logements ({count})",
    moreUnits: "+{count} de plus",
    andMore: "et {count} de plus",
    emptyList: "Vous n'avez encore connecté aucun compte SES Hospedajes.",
    withoutAccountTitle: "Sans compte :",
    withoutAccountText: "Leurs check-ins ne sont pas déclarés à SES Hospedajes.",
    addAccount: "Ajouter un compte",
    edit: "Modifier",
    remove: "Retirer",
    newTitle: "Nouveau compte SES Hospedajes",
    editTitle: "Modifier le compte SES Hospedajes",
    aliasLabel: "Nom du compte (facultatif)",
    aliasPlaceholder: "Ex. : Penthouses, Appartement 2B",
    aliasHint: "Sert uniquement à le reconnaître ici. S'il est vide, le compte est affiché par son code d'établissement.",
    loginTitle: "Accès au Ministère",
    loginSame: "Le même utilisateur et mot de passe",
    loginSameHint: "Vous ne saisissez que les codes de ce compte.",
    loginOwn: "Un autre utilisateur et mot de passe",
    loginFrom: "Reprendre l'accès de",
    passwordKeep: "Laissez vide pour ne pas le changer",
    passwordNeeded: "Saisissez le mot de passe du nouvel utilisateur.",
    passwordShared: "Cet utilisateur est utilisé par {count} autre(s) compte(s) de l'annonce : si vous changez le mot de passe, il est mis à jour dans tous.",
    scopeTitle: "À quels logements s'applique-t-il ?",
    scopeWhole: "Annonce entière",
    scopeWholeHint: "Utilisé par les logements qui n'ont pas d'autre compte.",
    scopeWholeTaken: "« {name} » l'est déjà.",
    scopeUnits: "Seulement certains logements",
    scopeUnitsHint: "Vous choisissez lesquels.",
    unitNow: "actuellement : {name}",
    unitNowWhole: "actuellement : celui de l'annonce entière",
    unitNowNone: "sans compte",
    leftWithout: "sans compte après l'enregistrement. Leurs check-ins ne seront plus déclarés à SES Hospedajes.",
    leftToWhole: "après l'enregistrement, la déclaration se fera avec le compte de l'annonce entière « {name} ».",
    errUnits: "Choisissez au moins un logement.",
    errDefaultExists: "Cette annonce a déjà un compte pour tous ses logements.",
    errDuplicate: "Vous avez déjà ce compte dans cette annonce. Modifiez-le et ajoutez-y des logements.",
    errCopyFrom: "Impossible de reprendre l'accès de ce compte. Saisissez-le à la main.",
    savedValidated: "Compte enregistré et validé par le Ministère.",
    savedNotValidated: "Enregistré, mais le Ministère refuse les données. Vérifiez-les.",
    savedUnchecked: "Compte enregistré. Le TRA ne permet pas de vérifier le jeton à l'avance : on le saura au premier envoi.",
    passwordSynced: "Mot de passe mis à jour aussi dans {count} compte(s) du même utilisateur.",
    removeTitle: "Retirer ce compte ?",
    removeNoUnits: "Le compte « {name} » sera retiré. Aucun logement ne l'utilise.",
    removeToFallback: "« {name} » sera retiré. Les logements qui l'utilisent ({units}) déclareront avec le compte de l'annonce entière « {fallback} ».",
    removeToNothing: "« {name} » sera retiré. Les logements qui l'utilisent ({units}) n'auront plus de compte et leurs check-ins ne seront plus déclarés à SES Hospedajes.",
    removeConfirm: "Oui, retirer",
    removed: "Compte retiré.",
    removeError: "Impossible de retirer le compte.",
  },

  // Colombia — varias cuentas de SIRE y de TRA por anuncio (ColombiaAccounts.vue,
  // ColombiaAccountModal.vue y el aviso de cuentas de otro país en Autoridades.vue).
  co: {
    loading: "Chargement des comptes…",
    saving: "Enregistrement…",
    close: "Fermer",
    show: "Afficher",
    hide: "Masquer",

    badgeConnected: "Connecté",
    badgeError: "Erreur de validation",
    badgePending: "Non validé",
    badgeOnSend: "Vérifié à l'envoi",

    edit: "Modifier",
    remove: "Retirer",
    addAccount: "Ajouter un compte",

    appliesWhole: "Annonce entière :",
    appliesUnits: "Logements :",
    noUnits: "Aucun logement ne l'utilise",
    allUnits: "Tous les logements ({count})",
    moreUnits: "+{count} de plus",
    andMore: "et {count} de plus",
    withoutAccountTitle: "Sans compte :",

    scopeTitle: "À quels logements s'applique-t-il ?",
    scopeWhole: "Annonce entière",
    scopeWholeHint: "Utilisé par les logements qui n'ont pas d'autre compte.",
    scopeWholeTaken: "« {name} » l'est déjà.",
    scopeUnits: "Seulement certains logements",
    scopeUnitsHint: "Vous choisissez lesquels.",
    unitNow: "actuellement : {name}",
    unitNowWhole: "actuellement : celui de l'annonce entière",
    unitNowNone: "sans compte",
    leftToWhole: "après l'enregistrement, la déclaration se fera avec le compte de l'annonce entière « {name} ».",

    aliasLabel: "Nom du compte (facultatif)",
    aliasPlaceholder: "Ex. : Tour nord, Appartement 301",
    loginFrom: "Reprendre l'accès de",
    secretKeep: "Laissez vide pour ne pas le changer",

    errUnits: "Choisissez au moins un logement.",
    errDefaultExists: "Cette annonce a déjà un compte pour tous ses logements.",
    errDuplicate: "Vous avez déjà ce compte dans cette annonce. Modifiez-le et ajoutez-y des logements.",
    errCopyFrom: "Impossible de reprendre l'accès de ce compte. Saisissez-le à la main.",
    errNoListing: "Nous ne trouvons pas l'annonce. Rouvrez l'écran.",
    saveError: "Impossible d'enregistrer le compte.",

    removeTitle: "Retirer ce compte ?",
    removeConfirm: "Oui, retirer",
    removeNoUnits: "Le compte « {name} » sera retiré. Aucun logement ne l'utilise.",
    removeToFallback: "« {name} » sera retiré. Les logements qui l'utilisent ({units}) déclareront avec le compte de l'annonce entière « {fallback} ».",
    removeToNothing: "« {name} » sera retiré. Les logements qui l'utilisent ({units}) n'auront plus de compte et ne déclareront plus à {authority}.",
    removed: "Compte retiré.",
    removeError: "Impossible de retirer le compte.",

    sire: {
      name: "SIRE",
      subtitle: "Sistema de Información para el Registro de Extranjeros — Migración Colombia",
      intro: "Chaque logement déclare ses voyageurs au SIRE avec un compte. Vous pouvez utiliser un seul compte pour toute l'annonce ou en attribuer un autre à certains logements, par exemple si chaque appartement est enregistré avec son propre code d'établissement.",
      introSingle: "Connectez le compte avec lequel cette annonce déclare ses voyageurs au SIRE.",
      emptyList: "Vous n'avez encore connecté aucun compte SIRE.",
      withoutAccountText: "Leurs check-ins ne sont pas déclarés au SIRE.",
      newTitle: "Nouveau compte SIRE",
      editTitle: "Modifier le compte SIRE",
      modalSub: "Ce sont les données avec lesquelles vous vous connectez au SIRE",
      defaultName: "Établissement {code}",
      defaultNameDoc: "Document {document}",
      docTypeLabel: "Type de document",
      docType_CO_ID: "Carte d'identité citoyenne (cédula de ciudadanía)",
      docType_CO_FID: "Carte d'identité d'étranger (cédula de extranjería)",
      documentLabel: "Numéro du document",
      documentPlaceholder: "Ex. : 1012345678",
      documentHint: "C'est l'utilisateur avec lequel vous vous connectez au SIRE.",
      passwordLabel: "Mot de passe",
      passwordPlaceholder: "Le mot de passe du SIRE",
      passwordShared: "Ce document est utilisé par {count} autre(s) compte(s) de l'annonce : si vous changez le mot de passe, il est mis à jour dans tous.",
      estLabel: "Code d'établissement (facultatif)",
      estPlaceholder: "Ex. : 67890",
      estHint: "Nécessaire seulement si vous déclarez plusieurs logements avec le même accès. S'il est vide, celui que vous avez enregistré est utilisé.",
      loginTitle: "Accès au SIRE",
      loginSame: "Le même document et mot de passe",
      loginSameHint: "Vous ne saisissez que le code de ce compte.",
      loginOwn: "Un autre document et mot de passe",
      aliasHint: "Sert uniquement à le reconnaître ici. S'il est vide, le compte est affiché par son code d'établissement.",
      metaDoc: "Document",
      metaEst: "Établissement",
      leftWithout: "sans compte après l'enregistrement. Leurs check-ins ne seront plus déclarés au SIRE.",
      errDocument: "Saisissez le numéro du document.",
      errPassword: "Saisissez le mot de passe du SIRE.",
      errPasswordNeeded: "Saisissez le mot de passe du nouveau document.",
      savedValidated: "Compte enregistré et validé par le SIRE.",
      savedNotValidated: "Enregistré, mais le SIRE refuse les données. Vérifiez-les.",
      savedUnchecked: "Compte enregistré. Le TRA ne permet pas de vérifier le jeton à l'avance : on le saura au premier envoi.",
    },

    tra: {
      name: "TRA",
      subtitle: "Registro de turistas alojados — Ministerio de Comercio, Industria y Turismo",
      intro: "Chaque logement envoie son rapport au TRA avec un compte. Vous pouvez utiliser un seul compte pour toute l'annonce ou en attribuer un autre à certains logements : chaque RNT identifie un logement.",
      introSingle: "Connectez le compte avec lequel cette annonce envoie son rapport au TRA.",
      emptyList: "Vous n'avez encore connecté aucun compte TRA.",
      withoutAccountText: "Leurs séjours ne sont pas déclarés au TRA.",
      newTitle: "Nouveau compte TRA",
      editTitle: "Modifier le compte TRA",
      modalSub: "Ce sont le token et le RNT de ce logement",
      defaultName: "RNT {rnt}",
      tokenLabel: "Token",
      tokenPlaceholder: "Collez votre token ici",
      tokenHint: "Vous le générez sur",
      loginTitle: "Accès au TRA",
      loginSame: "Le même token",
      loginSameHint: "Vous ne saisissez que le RNT de ce compte.",
      loginOwn: "Un autre token",
      rntLabel: "RNT",
      rntPlaceholder: "Ex. : 123456",
      rntHint: "Le Registro Nacional de Turismo de ce logement. C'est ce qui identifie l'établissement auprès du TRA.",
      aliasHint: "Sert uniquement à le reconnaître ici. S'il est vide, le compte est affiché par son RNT.",
      metaRnt: "RNT",
      metaToken: "Token",
      leftWithout: "sans compte après l'enregistrement. Leurs séjours ne seront plus déclarés au TRA.",
      errToken: "Collez le token du TRA.",
      errRnt: "Le RNT est un nombre. Vérifiez-le.",
      savedValidated: "Compte enregistré et validé par le TRA.",
      savedNotValidated: "Enregistré, mais le TRA refuse les données. Vérifiez-les.",
      savedUnchecked: "Compte enregistré. Le TRA ne permet pas de vérifier le jeton à l'avance : on le saura au premier envoi.",
    },

    foreign: {
      ses: "SES Hospedajes (Espagne)",
      colombia: "SIRE et TRA (Colombie)",
      title: "Il reste des comptes {name}",
      text: "Cette annonce n'est plus dans ce pays, donc ce compte ne déclare rien. | Cette annonce n'est plus dans ce pays, donc ces {count} comptes ne déclarent rien.",
      remove: "Les retirer",
      removeTitle: "Retirer les comptes en trop ?",
      removeMessage: "Le compte {name} qui restait sera retiré. Cela n'affecte pas l'autorité que vous utilisez maintenant. | Les {count} comptes {name} qui restaient seront retirés. Cela n'affecte pas l'autorité que vous utilisez maintenant.",
      removed: "Comptes retirés.",
      removeError: "Impossible de les retirer.",
    },
  },

  // CheckoutMessage.vue
  checkoutMsg: {
    title: "Message de check-out",
    subtitle: "Un rappel de check-out envoyé la veille au soir du départ. Rédigez votre propre texte et utilisez les variables disponibles.",
    loading: "Chargement…",
    enableTitle: "Envoyer le message de check-out",
    enableSub: "Il sera envoyé automatiquement {day} à {time}.",
    dayLast: "le jour du départ",
    dayBefore: "la veille du départ",
    cloneTitleNoun: "message de check-out",
    cloneItemNoun: "le message de check-out",
    whenLabel: "Quand l'envoyer",
    dayBeforeShort: "La veille",
    dayLastShort: "Jour du départ",
    atLabel: "À",
    timeHint: "Le jour du départ, l'heure ne peut pas être postérieure au check-out ({time}).",
    otaTitle: "Envoyer aussi via l'OTA",
    textLabel: "Texte du message de check-out",
    translate: "Traduire",
    translating: "Traduction…",
    attach: "Joindre",
    uploading: "Téléversement…",
    attachTitle: "Pièces jointes du message de check-out",
    emojis: "Émojis",
    searchEmoji: "Rechercher un émoji…",
    variables: "Variables",
    varsHint: "Appuyez pour les insérer. Elles sont remplacées par les données réelles de la réservation à l'envoi.",
    uploadDone: "Envoyé. Enregistrement sur le serveur…",
    attachLimits: "Images et PDF jusqu'à {file} Mo · Vidéos MP4 jusqu'à {video} Mo.",
    attachLimitsWhy: "Ce sont les limites autorisées par WhatsApp.",
    tipBefore: "Utilisez",
    tipTextWord: "texte",
    tipMid: "pour mettre quelque chose en",
    tipBoldWord: "gras",
    tipAfter: "(mise en forme WhatsApp). Le client reçoit le message dans sa langue si elle est configurée.",
    attachShared: "Pièces jointes · partagées entre toutes les langues",
    delete: "Supprimer",
    autosaveNote: "Les modifications sont enregistrées automatiquement.",
    preview: "Aperçu",
    online: "en ligne",
    previewHint: "Se met à jour avec vos paramètres",
    dayOfCheckout: "Jour du départ",
    eveOfCheckout: "Veille du départ",
    yourAccommodation: "votre hébergement",
    uploadSent: "{sent} sur {total} Mo",
    filesCount: "{count} fichiers",
    placeholder: "par ex. Bonjour {guest} 👋 Votre séjour à {property} se termine demain. L'heure de check-out est {time}. Merci de votre visite !",
    varGuestName: "Nom du client",
    varPropertyName: "Nom de l'hébergement",
    varCheckoutTime: "Heure de check-out",
    today: "aujourd'hui",
    tomorrow: "demain",
    previewDefault: "Bonjour, *{guest}* 👋\n\nPetit rappel : votre séjour à *{property}* se termine {when}.\n\n🕚 L'heure limite de check-out est *{time}*.\n\nMerci beaucoup pour votre séjour. Bon voyage ! 😊",
    errVideoFormat: "❌ {name} est une vidéo {ext} et WhatsApp ne prend en charge que le MP4. Convertissez-la en MP4 et téléversez-la à nouveau.",
    errFileSize: "❌ {name} fait {size} Mo et le maximum est de {max} Mo. ",
    errFileSizeVideo: "WhatsApp ne prend pas en charge les vidéos plus volumineuses : compressez-la ou raccourcissez-la.",
    errFileSizeFile: "WhatsApp ne prend pas en charge les fichiers plus volumineux.",
    attachUploaded: "Pièce(s) jointe(s) téléversée(s) avec succès",
    attachUploadError: "Erreur lors du téléversement des pièces jointes",
    attachDeleted: "Pièce jointe supprimée",
    attachDeleteError: "Impossible de supprimer la pièce jointe",
    loadError: "Impossible de charger le message de check-out.",
    translateEmpty: "Rédigez le message dans la langue active avant de traduire.",
    translateSuccess: "{count} langues traduites ! Vérifiez chaque onglet.",
    translatePartial: "{ok} traduites, {fail} échouées.",
    translateError: "Impossible de traduire. Veuillez réessayer.",
    saved: "Message de check-out enregistré",
    saveError: "Impossible d'enregistrer le message de check-out.",
  },
};
